// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.max-width-800px[data-v-7746b8ec]{max-width:800px}`, "",{"version":3,"sources":["<input css 12>"],"names":[],"mappings":"AAAA,kCAAiB,eAAe","sourcesContent":[".max-width-800px{max-width:800px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
